import type { FC } from 'react';
import { useEffect, useState } from 'react';

const BUTTON_ID = 'consent-mode-button';

export const ConsentModeButton: FC = () => {
  const [isClicked, setIsClicked] = useState(false);

  const onButtonClick = () => {
    setIsClicked(true);

    window.gtag('consent', 'update', {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      analytics_storage: 'granted'
    });

    window.uetq = window.uetq || [];
    window.uetq.push('consent', 'update', {
      ad_storage: 'granted'
    });
  };

  useEffect(() => {
    const button = document.querySelector(`#${BUTTON_ID}`) as HTMLButtonElement;

    button?.click?.();
  }, []);

  if (isClicked) {
    return null;
  }

  return (
    <div
      className='flex justify-center items-center'
      style={{
        backgroundColor: 'transparent',
        color: 'transparent'
      }}
    >
      <p>
        We use cookies to ensure you get the best experience on our website. By clicking "Consent Mode", you agree to
        the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our
        marketing efforts.
      </p>
      <button
        id={BUTTON_ID}
        aria-label='Consent Mode'
        onClick={onButtonClick}
      >
        Consent Mode
      </button>
    </div>
  );
};
